/**
 * Mapeia os campos padrão de CAMPOS_PESQUISA (pesquisas.constants.js) para as
 * chaves de `filtros` do contrato do endpoint novo.
 */
const CAMPOS_PADRAO_PARA_FILTRO = {
  nroProcesso: 'numeroProcesso',
  cnpjCpfDevedor: 'cpfCnpjDevedor',
  nomeDevedor: 'nomeDevedor',
  codigoCliente: 'codigoCliente',
  nomeCliente: 'nomeCliente',
  negociador: 'idUsuarioNegociador',
  agendamento: 'idTipoAgendamento',
  cidadeDevedor: 'cidadeDevedor',
  uf: 'uf',
  estadoDevedor: 'idEstadoDevedor',
  cpfCnpjCliente: 'cpfCnpjCliente',
  pasta: 'idFasePasta',
  fase: 'idFase',
  dataAgendamento: 'dataAgendamento',
  codigoDevedor: 'codigoDevedorNoCliente',
  status: 'idStatusProcesso',
};

const PERIODOS_PADRAO_PARA_FILTRO = {
  periodoEnvioFase: 'periodoEnvioFaseAtual',
  abertosEntre: 'periodoAbertura',
  recebidosEntre: 'periodoRecebimento',
};

const SORT_PADRAO = ['nroProcesso,ASC'];

/**
 * Mapeamento dos params de cada item de PESQUISAS_PRONTAS (pesquisas.constants.js)
 * para as chaves de `filtros`. Itens sem params (minhasRequisicoes,
 * titulosNaoVencidos, ajuizados) não precisam de entrada aqui.
 */
const PARAMS_PESQUISA_PRONTA = {
  ultimaParcelaQuitada: {
    periodos: { periodo: 'periodo' },
  },
  acordosVencidos: {
    campos: { negociador: 'idUsuarioNegociador' },
    periodos: { periodo: 'periodo' },
  },
  naoTrabalhados: {
    campos: { fase: 'idFase', negociador: 'idUsuarioNegociador' },
  },
  expirados: {
    campos: { situacao: 'situacao', codCliente: 'codigoCliente' },
  },
  prazoNoPeriodo: {
    campos: { tipoAgendamento: 'idTipoAgendamento' },
    periodos: { periodoAgendamento: 'periodoAgendamento' },
  },
};

function periodoPreenchido(periodo) {
  return Boolean(periodo && (periodo.inicio || periodo.fim));
}

function campoPreenchido(valor) {
  return valor !== undefined && valor !== null && valor !== '';
}

function copiarCamposPreenchidos(origem = {}, mapaCampos, filtros) {
  Object.entries(mapaCampos).forEach(([campoOrigem, chaveFiltro]) => {
    const valor = origem[campoOrigem];
    if (campoPreenchido(valor)) filtros[chaveFiltro] = valor;
  });
}

function copiarPeriodosPreenchidos(origem = {}, mapaPeriodos, filtros) {
  Object.entries(mapaPeriodos).forEach(([campoOrigem, chaveFiltro]) => {
    const periodo = origem[campoOrigem];
    if (periodoPreenchido(periodo)) filtros[chaveFiltro] = periodo;
  });
}

function montarFiltrosPadrao(valores) {
  const filtros = {};
  copiarCamposPreenchidos(valores, CAMPOS_PADRAO_PARA_FILTRO, filtros);
  copiarPeriodosPreenchidos(valores, PERIODOS_PADRAO_PARA_FILTRO, filtros);
  return filtros;
}

function montarFiltrosPesquisaPronta(valores, idPesquisaPronta) {
  const definicao = Object.prototype.hasOwnProperty.call(PARAMS_PESQUISA_PRONTA, idPesquisaPronta)
    ? PARAMS_PESQUISA_PRONTA[idPesquisaPronta]
    : {};
  const { campos = {}, periodos = {} } = definicao;
  const valoresDaPronta = Object.keys({ ...campos, ...periodos }).reduce(
    (acumulado, paramId) => ({
      ...acumulado,
      [paramId]: valores[`${idPesquisaPronta}.${paramId}`],
    }),
    {},
  );

  const filtros = {};
  copiarCamposPreenchidos(valoresDaPronta, campos, filtros);
  copiarPeriodosPreenchidos(valoresDaPronta, periodos, filtros);
  return filtros;
}

/**
 * Traduz o estado do formulário de PesquisaProcessosPage.jsx para o payload
 * de POST {CORE}/processos/pesquisar (contrato em
 * docs/architecture/plano-pesquisa-processos-backend.md).
 *
 * @param {Object} valores - Estado `valores` da página: ids de CAMPOS_PESQUISA
 *   quando não há Pesquisa Pronta ativa, ou chaves namespaced
 *   `${idPesquisaPronta}.${paramId}` quando há.
 * @param {?string} pesquisaAtiva - id de PESQUISAS_PRONTAS selecionado, ou
 *   `null` quando a busca é pelos campos padrão da grid principal.
 * @returns {{tipoPesquisa: string, idPesquisaPronta: ?string, filtros: Object, sort: string[]}}
 */
export function montarPayloadPesquisa(valores, pesquisaAtiva) {
  if (pesquisaAtiva) {
    return {
      tipoPesquisa: 'PRONTA',
      idPesquisaPronta: pesquisaAtiva,
      filtros: montarFiltrosPesquisaPronta(valores, pesquisaAtiva),
      sort: SORT_PADRAO,
    };
  }

  return {
    tipoPesquisa: 'PADRAO',
    idPesquisaPronta: null,
    filtros: montarFiltrosPadrao(valores),
    sort: SORT_PADRAO,
  };
}
